/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { urlCatalogoSeccion } from "constants/urls";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { scrollTop } from "utils/funciones";

const LoadingMessage = () => (
  <React.Fragment>
    Estás ingresando a un sitio certificado por AIG,{" "}
    <strong
      className='text-primary font-futura-medium'
      style={{ fontWeight: "bold", fontSize: "27px" }}>
      ¡Gracias por tu confianza!
    </strong>
  </React.Fragment>
);

const API = ApiKeyFetch.instance();

const useParametrosSeccion = ({ codigoSeccion = "personas" }) => {
  const [data, setData] = useState(null);
  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const [loading, setLoading] = useState(true);
  const init = useCallback(async () => {
    setLoading(true);
    const usuarioId = dataUsuario?.sesionSuscriptor
      ? dataUsuario?.sesionSuscriptor?.cliCodigoCore || ""
      : dataUsuario?.cliCodigoCore || "";
    const Data = { codigoSeccion, usuarioId };

    // const res = await consumirServicioEncirptacion(urlCatalogoSeccion, Data);
    const res = await API.post(urlCatalogoSeccion, Data);
    if (res.transaccion && res.datos) {
      setData({
        cotizadores: res.datos.cotizadores.filter((cotizador) => {
          if (!dataUsuario.userIsLoggedIn && cotizador.titulo === "PyMes") {
            return false;
          }
          return true;
        }),
      });
    }
    setLoading(false);
    scrollTop();
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return { loading, setLoading, data, setData, message: <LoadingMessage /> };
};

export default useParametrosSeccion;
